import axios from 'axios';
import { API_URL } from '../config';

// Helper for development-only logging
const isDev = process.env.NODE_ENV === 'development';
const devLog = (message, ...args) => {
  if (isDev) {
    console.log(`[API] ${message}`, ...args);
  }
};

// Create axios instance with baseURL "/api" relative path for flexibility
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // SECURITY: Send cookies with requests
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      devLog(`Request to ${config.url} - Token attached`);
    } else {
      devLog(`Request to ${config.url} - No token found`);
    }
    
    return config;
  },
  (error) => {
    devLog('Request error:', error.message);
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors gracefully
api.interceptors.response.use(
  (response) => {
    devLog(`Response from ${response.config.url} - Status: ${response.status}`);
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    
    devLog(`Response error from ${url} - Status: ${status}`, error.message);
    
    if (status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('auth_token');
      devLog('401 Unauthorized - Token cleared, redirecting to login');
      
      if (window.location.pathname !== '/login' && window.location.pathname !== '/auth/callback') {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;

